import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';
import { IKnm248 } from '../../../APIPackage/KnmModule/interfaces/IKnm248';
import { IKnmRequirementsNpa248 } from '../../../APIPackage/KnmModule/interfaces/IKnmRequirementsNpa248';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';
import { convertViolationsFormValuesToKnmData } from './convertViolationsFormValuesToKnmData';

export const convertRequirementsNpaFormValueToKnmData = (value: IKnmErknmForm): IKnm248['requirementsNew'] => {
  const { requirementsNpaErknm } = value;

  if (!requirementsNpaErknm) return null;

  return requirementsNpaErknm.map(item => {
    const { npa, structuralUnit, mandatory, inspectionResults } = item;
    const newItem: IKnmRequirementsNpa248 = {
      guid: item.guid,
      npaId: npa.id,
      number: npa.number || null,
      title: npa.title || null,
      acceptanceDate: formatDate({
        date: npa.acceptanceDate ?? '',
        dateFormat: SYSTEM_DATE_FORMAT_FNS,
        parseFormat: DATE_FORMAT_LONG_FNS,
      }),
      structuralUnit: {
        id: structuralUnit.id,
        title: structuralUnit.title || null,
        mandatoryRequirements: mandatory
          ? mandatory.map(mandatoryItem => ({
              id: mandatoryItem.mandatory.id,
              title: mandatoryItem.mandatory.title,
              category: mandatoryItem.category
                ? {
                    id: mandatoryItem.category.id,
                    name: mandatoryItem.category.name,
                  }
                : null,
              violations: mandatoryItem.violations?.length
                ? convertViolationsFormValuesToKnmData(mandatoryItem.violations, undefined)
                : null,
            }))
          : null,
      },
      inspectionResults,
    };

    return newItem;
  });
};
